export type RowActionVariant =
  | "default"
  | "primary"
  | "success"
  | "warning"
  | "danger"
  | "purple"
  | "neutral";

const CHIP_BASE =
  "inline-flex items-center justify-center rounded-md px-2.5 py-1.5 text-xs font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50";

export function rowActionChipClass(variant: RowActionVariant = "default"): string {
  switch (variant) {
    case "primary":
      return `${CHIP_BASE} bg-brand-500/12 text-brand-700 hover:bg-brand-500/20 dark:bg-brand-500/20 dark:text-brand-200`;
    case "success":
      return `${CHIP_BASE} bg-emerald-500/12 text-emerald-700 hover:bg-emerald-500/20 dark:bg-emerald-500/15 dark:text-emerald-200`;
    case "warning":
      return `${CHIP_BASE} bg-amber-500/12 text-amber-700 hover:bg-amber-500/20 dark:bg-amber-500/15 dark:text-amber-200`;
    case "danger":
      return `${CHIP_BASE} bg-red-500/12 text-red-700 hover:bg-red-500/20 dark:bg-red-500/15 dark:text-red-200`;
    case "purple":
      return `${CHIP_BASE} bg-purple-500/12 text-purple-700 hover:bg-purple-500/20 dark:bg-purple-500/15 dark:text-purple-200`;
    case "neutral":
      return `${CHIP_BASE} bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-white/10 dark:text-gray-200 dark:hover:bg-white/15`;
    default:
      return `${CHIP_BASE} bg-blue-500/12 text-blue-700 hover:bg-blue-500/20 dark:bg-blue-500/15 dark:text-blue-200`;
  }
}

export const ROW_ACTIONS_TRIGGER =
  "inline-flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-semibold text-gray-700 shadow-sm transition-colors hover:bg-gray-50 dark:border-white/[0.08] dark:bg-surface-elevated dark:text-slate-200 dark:hover:bg-white/[0.06]";
